'use strict';

export default class SupportEmailController {
  constructor(config) {
    'ngInject';

    this.supportEmail = config.supportEmail;
  }
}



// WEBPACK FOOTER //
// ./app/src/common/support_email/support_email.js